import React, { useEffect } from "react";
import { connect } from "react-redux";

import MealPackageUpdate from "./MealPackageUpdate";
import Menu from "./Menu";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";

const MealPackageUpdateContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("accounting");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("mealpackageupdate");
    props.setMenuLeftItemIndex("");
  }, []);
  return <MealPackageUpdate {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MealPackageUpdateContainer);



// WEBPACK FOOTER //
// src/pages/accounting/MealPackageUpdate.container.js